::ng-deep particle-dac6-forms-content{display:flex;width:100%}::ng-deep particle-dac6-forms-content .pos-relative{height:initial}
/*# sourceMappingURL=dac6-forms-content.component-RXFNUOKD.css.map */
